import styled from "styled-components";
// eslint-disable-next-line
import { primary } from "../../constants/colors";

export const TaskPickerForm = styled.form`
  margin: 1rem 0;
  padding: 0 10px;
`;

export const TaskPickerSelect = styled.select`
  width: 100%;
  height: 25px;
  border: none;
  padding: 0 10px;
`;

// @media (min-width: 768px) {
//   font-size: 2rem;
//   margin: 0;
// }
